let loadingPromise: Promise<void> | null = null;

export function ensureGoogleMapsLoaded(): Promise<void> {

  if ((window as any).google?.maps) {
    return Promise.resolve();
  }

  if (!loadingPromise) {
    const existing = document.querySelector(
      'script[src*="maps.googleapis.com/maps/api/js"]'
    );

    if (!existing) {
      return Promise.reject(
        new Error(
          'Google Maps is not loaded. Host app must include the Google Maps script.'
        )
      );
    }

    loadingPromise = new Promise<void>((resolve, reject) => {
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener(
        'error',
        () => reject(new Error('Google Maps failed to load')),
        { once: true }
      );
    });
  }

  return loadingPromise;
}
